/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import CustomerStories from "./Stories";

export default CustomerStories;
